/*
 * Copyright (c) 2022 EGT Digital - All rights reserved.
 *
 * File: StatusContainer
 *
 * Written by Martin Lubenov <martin.lubenov@egt-digital.com> on  27.10.22 11:25 am.
 * Last modified: 27.10.22 11:25 am.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { useSettings } from '../contexts/SettingsContext';
import Balance from './Balance';
import Exit from './Exit';
import Search from './Search';
import Settings from './Settings';

const StatusContainer = ({ onClickSearch, onClickSettings }: IStatusContainerProps) => {
    const [{ mode, isSearchOpen, isSettingsModalOpen }] = useSettings();

    return (
        <div className={`egt_status_container egt_status_container_${mode}`}>
            <Exit className={mode === 'mobile' ? 'portrait-only' : ''} />
            <Balance mode={mode} />
            <Search
                onClick={onClickSearch}
                active={isSearchOpen}
                className={mode === 'mobile' ? 'portrait-only' : ''}
            />
            <Settings
                mode={mode}
                className={mode === 'mobile' ? 'portrait-only' : ''}
                isOpen={isSettingsModalOpen}
                onClick={onClickSettings}
            />
        </div>
    );
};

interface IStatusContainerProps {
    onClickSearch?: () => void;
    onClickSettings?: () => void;
}

export default StatusContainer;
